// extracted by mini-css-extract-plugin
export default {"root":"CX6loGMOTQK9lUUj5msd","wrap":"y34TOJ4GDjcvKsix_Cqa","main":"UZAzo5gcNFyh7lQh6Fo_","header":"W_AQW7YLRmjwVfEnF63c"};